module.exports = __webpack_public_path__ + "static/media/t2-img3.2805b6ad.png";